import React from "react";
import { List, ListItem } from "@mui/material";
import { SkeletonEquipmentItem } from "../../../common/Utils/Skeleton/SkeletonComponents";

const EquipmentListSkeleton = ({ count = 1, hideEquipmentImage = false }) => (
  <List disablePadding>
    {Array.from({ length: count }).map((_, i) => (
      <ListItem key={i} divider sx={{ py: 6 }}>
        <SkeletonEquipmentItem hideEquipmentImage={hideEquipmentImage} />
      </ListItem>
    ))}
  </List>
);

export default EquipmentListSkeleton;
